module.exports = __webpack_public_path__ + "img/trusted-ppe.c607158e.png";